
define('mapa-imoveis-controller',[
    'mapa-imoveis-resource',

], function () {

    var app = angular.module('mapa.imoveis.controller', [
        'mapa.imoveis.resource',
        'default.resource',
        'imovel.resource',
        'ui.mask',
        'flow',

    ]);

    // Função que compara e retira elementos da lista alvo que não estão na lista base.
    syncArrays = (base, target) => {
        if (base.length <= 0) target = [];
        var i = 0
        while (i < target.length) {
            var found = false;
            base.some(elem=>{
                if (elem.ist_codigo && elem.ist_codigo == target[i]) {found = true;}
                if (elem.imo_bairro && elem.imo_bairro == target[i]) {found = true;}
            })
            if (!found) {
                target.splice(i, 1);
                i--; // Retorna um para não pular um elemento por ter removido um.
            }
            i++;
        }
    };

    app.controller('MapaImoveisController', ['$scope', '$rootScope', 'MapaImoveis', '$mdDialog', 'Imovel', 'Default', '$timeout', '$localStorage', function ($scope, $rootScope, MapaImoveis, $mdDialog, Imovel, Default, $timeout, $localStorage) {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
        $("#ajaxbloq").fadeIn();
        var pesquisaTimeout;
        $scope.subtipos = [];
        $scope.bairros = [];
        $scope.initialLatitude = -14;
        $scope.initialLongitude = -53;
        $scope.pagina = 'imoveis';
        $scope.filtro = {
            showOrderOptions: false,
            page: 1,
            limit: 20,
            location: null,
            tipo: [],
            subtipos: [],
            cidade: null,
            bairros: [],
            order: {
                orderby: 'desc'
            },
            operacao: 'T',
        }

        $scope.setRangeSlider = () => {
            let brReal = Intl.NumberFormat("pt-BR", {
                style: "currency",
                currency: "BRL",
            });
            $scope.slider = {
                rangeSliderMin: 0,
                rangeSliderMax: $scope.filtro && $scope.filtro.operacao != 'T' ? $scope.filtro.operacao.maxval : 1000000,
            }
            $scope.filtro.rangeMinVal = 0,
            $scope.filtro.rangeMaxVal = $scope.filtro && $scope.filtro.operacao != 'T' ? $scope.filtro.operacao.maxval : 1000000,
            $("#slider-range").slider({
                range: true,
                min: $scope.slider.rangeSliderMin,
                max: $scope.slider.rangeSliderMax,
                step: $scope.filtro && $scope.filtro.operacao != 'T' && $scope.filtro.operacao.ttpr_codigo == 1 ? 500 : 1,
                values: [$scope.filtro.rangeMinVal, $scope.filtro.rangeMaxVal],
                slide: function (event, ui) {
                    $scope.filtro.rangeMinVal = ui.values[0];
                    $scope.filtro.rangeMaxVal = ui.values[1];
                    $("#slider-amount-min").val(brReal.format($scope.filtro.rangeMinVal)); // Debug: ng-model não atualiza em tempo real os dados do input acima do slider.
                    $("#slider-amount-max").val(brReal.format($scope.filtro.rangeMaxVal)); // Debug: ng-model não atualiza em tempo real os dados do input acima do slider.
                },
            });
            $("#slider-amount-min").val(brReal.format($scope.filtro.rangeMinVal)); // Debug: ng-model não atualiza em tempo real os dados do input acima do slider.
            $("#slider-amount-max").val(brReal.format($scope.filtro.rangeMaxVal)); // Debug: ng-model não atualiza em tempo real os dados do input acima do slider.
        };

        $scope.setRangeSlider();
        $scope.orderList = [
            {
                'name': 'Mais recente',
                'column': 'imo_codigo',
                'orderby': 'desc'
            },
            {
                'name': 'Mais antigo',
                'column': 'imo_codigo',
                'orderby': 'asc'
            },
            {
                'name': 'Maior valor',
                'column': 'imtp_valor',
                'orderby': 'desc'
            },
            {
                'name': 'Menor valor',
                'column': 'imtp_valor',
                'orderby': 'asc'
            },
        ]
        // $scope.tipoSubtipo = tipoSubtipo;
        // Valores iniciais Brasil: latitude: -14 longitude: -53. 
        var map = L.map('leaf-map').setView([$scope.initialLatitude, $scope.initialLongitude], 5);
        var markers = null;
        L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
            maxZoom: 19,
            attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
        }).addTo(map);

        // Leaflet ajusta o tamanho do mapa no clique, de tal modo dando scroll pra baixo e sumindo com o header, o código abaixo previne isso.
        map.on('click', function() {
            $('body').scrollTop(0);
        });
        map.on('moveend', function (ev) {
            $scope.filtro.location = map.getBounds();
            $scope.filtro.page = 1;
            $timeout.cancel(pesquisaTimeout);
            pesquisaTimeout = $timeout(()=>{
                $scope.pesquisa();
            }, 1500);
        });

        var iconDefault = L.divIcon({
            className: 'custom-map-icon',
            html: '<div><span class="material-symbols-outlined" style="font-size: 30px">location_on</span></div>',
            iconSize: [28, 38],
            iconAnchor: [0, 0],
            popupAnchor: [15, 0],
        });
        var iconFav = L.divIcon({
            className: 'custom-map-icon liked',
            html: '<div><span class="material-symbols-outlined" style="font-size: 30px">location_on</span></div>',
            iconSize: [28, 38],
            iconAnchor: [0, 0],
            popupAnchor: [15, 0],
        });

        $scope.resetCluster = () => {
            if (markers) {
                markers.clearLayers();
            }
            markers = L.markerClusterGroup({
                spiderfyOnMaxZoom: false,
                showCoverageOnHover: false,
                animate: true,
                animateAddingMarkers: true,
                disableClusteringAtZoom: 19,
            });
        };

        searchImoveisListing = ()=>{
            MapaImoveis.getImoveisByLocationListing($scope.filtro).then(function (result) {
                let brReal = Intl.NumberFormat("pt-BR", {
                    style: "currency",
                    currency: "BRL",
                });
                // Habilita TODOS os eventos do mapa

                $scope.filtros = result.data;
                $scope.cidades =  $scope.cidades ?  $scope.cidades : $scope.filtros.cidades;
                $scope.filtros.tblpreco = result.data.tblpreco
                $scope.imoveis = [];
                $scope.imoveis = $scope.filtros.imoveis;
                $scope.siteDomain = $scope.filtros.siteDomain;
                if ($scope.imoveis.length > 0) {
                    $scope.count = $scope.filtros.imoveis[0].count; // Count vem em todos os imóveis, mas será pego do primeiro
                    $scope.totalPages = Math.ceil($scope.count / $scope.filtro.limit);
                    $scope.buildPaginationList($scope.filtro.page, 1, $scope.totalPages);
                    $scope.imoveis.forEach(imovel => {
                        if (imovel.tabeladepreco && imovel.tabeladepreco.length > 0) {
                            imovel.tabeladepreco.forEach(preco => {
                                preco.valor_format = brReal.format(preco.imtp_valor);
                                preco.valor_format_promocao = brReal.format(preco.imtp_promocao_valor);
                            });
                        };
                    });
                    
                } else {
                    $scope.filtro.operacao = 'T';
                }
                $scope.checkFavoritos();
            }).catch(function (e) {
                $("#ajaxbloq").fadeOut();
            });
        };

        searchImoveisMap = ()=>{
            MapaImoveis.getImoveisByLocationMap($scope.filtro).then(function (result) {
                let brReal = Intl.NumberFormat("pt-BR", {
                    style: "currency",
                    currency: "BRL",
                });
                
                $scope.imoveisMapa = result.data;
                $scope.resetCluster();
                $scope.imoveisMapa.forEach(imovel => {
                    imovel.marker = L.marker([imovel.imo_latitude, imovel.imo_longitude], { icon: iconDefault });
                    // imovel.marker.on('click', function (ev) {
                    //     imovel.marker.setIcon(iconPressed)
                    // });
                    $scope.imovel_tabeladepreco_html = ``;
                    if (imovel.tabeladepreco && imovel.tabeladepreco.length > 0) {
                        imovel.tabeladepreco.forEach(operacao => {
                            if (operacao.ttpr_valorsite && operacao.imtp_valor > 0 || operacao.imtp_valor != null || operacao.imtp_valor != '') {
                                if (!operacao.imtp_promocao) {
                                    $scope.imovel_tabeladepreco_html += `
                                <div class="precos-item" style="">
                                    <dl style="margin: 0;">
                                        <dt>${operacao.ttpr_nome}</dt>
                                        <dd class="body-color">
                                            ${brReal.format(operacao.imtp_valor)}
                                        </dd>
                                    </dl>
                                </div>
                                `;
                                };
                                if (operacao.imtp_promocao && operacao.imtp_promocao_valor) {
                                    $scope.imovel_tabeladepreco_html += `
                                <div class="precos-item" style="">
                                    <dl style="margin: 0;">
                                        <dt>${operacao.ttpr_nome}</dt>
                                        <dd class="body-color">
                                        <div class="valor-promocao-original-container">De: <span class="valor-promocao-original">${brReal.format(operacao.imtp_valor)}</span></div>
                                        <div class="valor-promocao-container">Por: <span class="valor-promocao">${brReal.format(operacao.imtp_promocao_valor)}</span></div>
                                        </dd>
                                    </dl>
                                </div>
                                `;
                            };
                        } else {
                                $scope.imovel_tabeladepreco_html += `
                            <div class="precos-item" style="">
                                <dl style="margin: 0;">
                                    <dt>${operacao.ttpr_nome}</dt>
                                    <dd class="body-color">
                                        Consulte-nos
                                    </dd>
                                </dl>
                            </div>
                            `;

                            }
                        });
                    };
                    imovel.tic_nome = imovel.tic_nome && imovel.tic_nome.includes(' ') ? imovel.tic_nome.replace(' ', '-') : imovel.tic_nome;
                    imovel.ist_nome = imovel.ist_nome && imovel.ist_nome.includes(' ') ? imovel.ist_nome.replace(' ', '-') : imovel.ist_nome;
                    let popup = imovel.marker.bindPopup(`
                        <a target="_blank" href="${$scope.siteDomain}/imovel/${imovel.imo_codigo}/${imovel.tic_nome}-${imovel.ist_nome}">
                            <div>
                                ${imovel.fot_caminho ? `<img src="${$scope.siteDomain}/uploads/imovel/${imovel.imo_codigo}/thumb/${imovel.fot_caminho}" class="imovel-image" lazyload/>` : ''}
                                ${!imovel.fot_caminho ? `<img src="${$scope.siteDomain}/site/public/theme/assets/no-image.jpeg" class="imovel-image" lazyload/>` : ''}
                                <div class="popup-imovel-info">
                                    <span>Imóvel: ${imovel.imo_codigo}</span>
                                    <h4 class="body-color">${imovel.tic_nome}, ${imovel.ist_nome}</h4>
                                    ${imovel.endereco_completo ? `<span>${imovel.endereco_completo}</span>` : ''}
                                    <div class="container-precos" style="
                                    display: flex;
                                    justify-content: space-between;">

                                    ${$scope.imovel_tabeladepreco_html}

                                    </div>
                                </div>
                            </div>
                        </a>
                    `, {
                        // Options here
                        maxWidth: 250
                    });

                    markers.addLayer(imovel.marker);
                    if (imovel.tabeladepreco && imovel.tabeladepreco.length > 0) {
                        imovel.tabeladepreco.forEach(preco => {
                            preco.valor_format = brReal.format(preco.imtp_valor);
                            preco.valor_format_promocao = brReal.format(preco.imtp_promocao_valor);
                        });
                    };
                });
                map._handlers.forEach(function (handler) {
                    handler.enable();
                });
                map.addLayer(markers);
                $scope.checkFavoritos();
            });
        };

        $scope.pesquisa = function () {
            // Desabilita TODOS os eventos do mapa
            map._handlers.forEach(function (handler) {
                handler.disable();
            });

            // Tentativa de implementação de funcionalidade de marcar item já pressionado
            // let iconPressed = L.divIcon({
            //     className: 'custom-map-icon',
            //     html: '<div><span class="material-symbols-outlined" style="font-size: 30px; color: #555555 !important">location_on</span></div>',
            //     iconSize: [28, 38],
            //     iconAnchor: [0, 0],
            //     popupAnchor: [15, 0],
            // });;
            $scope.filtro.location = map.getBounds();
            if ($scope.filtro.subtipos.length > 0) {syncArrays($scope.subtipos, $scope.filtro.subtipos);};
            if ($scope.filtro.bairros.length > 0) {syncArrays($scope.bairros, $scope.filtro.bairros);};
            searchImoveisListing();
            searchImoveisMap();
        };
        $scope.clearFiltros = () => {
            $scope.filtro = {
                show: true,
                showOrderOptions: false,
                page: 1,
                limit: 20,
                location: null,
                tipo: [],
                subtipos: [],
                cidade: null,
                bairros: [],
                order: {
                    orderby: 'desc'
                },
                operacao: 'T',
            }
            map.setView([$scope.initialLatitude, $scope.initialLongitude], 5,
                {
                    "animate": true,
                    "pan": {
                      "duration": 3
                    }
                }
                )

        };

        $scope.addImovelFavorite = (imovel) => {
            if (!$scope.usuarioLogado) {
                $scope.clickBtnLogin();
            } else {
                Default.addImovelFavorito({ imo_codigo: imovel.imo_codigo }).then(function (result) {
                    if (result.success) {
                        Default.reloadUsuarioLogado().then(function (result) {
                            $localStorage.token = result.token;
                            $rootScope.usuarioLogado = result.data;
                        });
                        imovel.liked = !imovel.liked;
                        if ($scope.imoveisMapa) {
                            $scope.imoveisMapa.some(el => {
                                if (el.imo_codigo == imovel.imo_codigo) {
                                    if (imovel.liked) {
                                        el.marker.setIcon(iconFav);
                                    } else {
                                        el.marker.setIcon(iconDefault);
                                    }
                                }
                            });
                        }
                        
                    };
                });
            }
        };

        $scope.checkFavoritos = () => {
            if ($scope.usuarioLogado) {
                if ($scope.usuarioLogado.ImoFavoritos && $scope.usuarioLogado.ImoFavoritos.length > 0) {
                    $scope.usuarioLogado.ImoFavoritos.forEach(imovel => {
                        if ($scope.imoveis) {
                            $scope.imoveis.some(el => {
                                if (el.imo_codigo == imovel.imo_codigo) {
                                    el.liked = true;
                                }
                            });
                        }
                        if ($scope.imoveisMapa) {
                            $scope.imoveisMapa.some(el => {
                                if (el.imo_codigo == imovel.imo_codigo) {
                                    el.marker.setIcon(iconFav);
                                }
                            });
                        }
                    })
                }
            }
        };

        $scope.zoomInMarker = (imovel) => {
            $scope.pagina = 'mapa'
            map.setView([imovel.imo_latitude, imovel.imo_longitude], 30,
                {
                    "animate": true,
                    "pan": {
                      "duration": 2
                    }
                }
                )
        };

        $scope.buildPaginationList = (currentPage, numberOfNeighbours, totalPages) => {
            $scope.listPages = [];

            // Controle para primeiras e últimas páginas: 
            if (3 == currentPage || totalPages -2 == currentPage){
                numberOfNeighbours = numberOfNeighbours + 1;
            } else if (2 == currentPage || totalPages -1 == currentPage) {
                numberOfNeighbours = numberOfNeighbours + 2;
            } else if (1 == currentPage || totalPages == currentPage) {
                numberOfNeighbours = numberOfNeighbours + 3;
            }
            // Adiciona os itens conforme o número de vizinhos desejado.
            for (let page = currentPage - numberOfNeighbours; page <= currentPage + numberOfNeighbours; page++) {
                $scope.listPages.push(page);
            }
            // Adiciona reticências no segundo item se necessário
            $scope.listPages = $scope.listPages.filter(page => page > 0 && page <= totalPages);
            if ($scope.listPages[0] != 1) {
                if ($scope.listPages[1] != 2) {
                    $scope.listPages.unshift('...');
                }
                $scope.listPages.unshift(1);
            }
            // Adiciona reticências no penúltimo item se necessário e adiciona o último item da paginação
            if ($scope.listPages[$scope.listPages.length - 1] != totalPages) {
                if ($scope.listPages[$scope.listPages.length - 2] != totalPages - 1) {
                    $scope.listPages.push('...');
                    $scope.listPages.push(totalPages);
                }
            }
        };

        $scope.pesquisa();

        $scope.changePage = (page) => {
            $timeout.cancel(pesquisaTimeout);
            pesquisaTimeout = $timeout(()=>{
                $scope.pesquisa();
            }, 1000);
            $scope.filtro.page = page;
            $scope.buildPaginationList(page, 1, $scope.totalPages);
        };

        $scope.setOrderBy = (orderObj) => {
            $scope.filtro.order = orderObj;
            $scope.filtro.showOrderOptions = false;
            $scope.pesquisa();
        };

        $scope.updateSliderVal = (elem) => {
            // Valor mínimo não deve ser maior que o máximo
            if ($scope.filtro.rangeMinVal > $scope.filtro.rangeMaxVal && elem == 'min') {
                $scope.filtro.rangeMinVal = $scope.filtro.rangeMaxVal; // console.log('Valor mínimo não deve ser maior que o máximo')
            }
            // Valor máximo não deve ser menor que o mínimo
            if ($scope.filtro.rangeMaxVal < $scope.filtro.rangeMinVal && elem == 'max') {
                $scope.filtro.rangeMaxVal = $scope.filtro.rangeMinVal;  // console.log('Valor máximo não deve ser menor que o mínimo')
            };
            // Caso valor máximo ultrapasse o limite, o limite se torna o valor máximo
            if ($scope.filtro.rangeMaxVal > $scope.slider.rangeSliderMax) {
                $scope.slider.rangeSliderMax = $scope.filtro.rangeMaxVal; $("#slider-range").slider("option", "max", $scope.filtro.rangeMaxVal);  // console.log('Valor máximo não deve ultrapassar o limite')
            };
            // Valor mínimo não deve ultrapassar o limite
            if ($scope.filtro.rangeMinVal < $scope.slider.rangeSliderMin) {
                $scope.filtro.rangeMinVal = $scope.slider.rangeSliderMin;  // console.log('Valor mínimo não deve ultrapassar o limite')
            };
            // Valores não podem ser nulos ou NaN
            if ((isNaN($scope.filtro.rangeMinVal) || !$scope.filtro.rangeMinVal)) {
                $scope.filtro.rangeMinVal = $scope.slider.rangeSliderMin
                // console.log('Valores não podem ser nulos ou NaN')
            }
            if ((isNaN($scope.filtro.rangeMaxVal) || !$scope.filtro.rangeMaxVal)) {
                $scope.filtro.rangeMaxVal = $scope.slider.rangeSliderMax
                // console.log('Valores não podem ser nulos ou NaN')
            }
            $("#slider-range").slider("option", "values", [$scope.filtro.rangeMinVal, $scope.filtro.rangeMaxVal]);
        };

        $scope.changeOperationFilter = (op) => {
            $scope.filtro.operacao = op;
            $scope.setRangeSlider();
        };

        $scope.searchBairro = () => {
            if ($scope.filtro.cidade) {
                MapaImoveis.searchBairros($scope.filtro.cidade.cid_codigo).then(result=>{
                    $scope.bairros = result.data;
                    if ($scope.bairros.length > 0) {
                        map.setView([$scope.bairros[0].imo_latitude, $scope.bairros[0].imo_longitude], 7,
                            {
                                "animate": true,
                                "pan": {
                                  "duration": 3
                                }
                            }
                            )
                    } else {
                        map.setView([$scope.initialLatitude, $scope.initialLongitude], 15,
                            {
                                "animate": true,
                                "pan": {
                                  "duration": 3
                                }
                            }
                        )
                    }
                    // $scope.pesquisa(); // Pesquisa já é feita pois move o mapa
                });
            }
        };

        $scope.populateSubtiposList = () => {
            $scope.subtipos = [];
            $scope.filtro.tipos.forEach(tic_codigo => {
                $scope.filtros.tipoCadastro.some(el => {
                    if (el.tic_codigo == tic_codigo) {
                        $scope.subtipos = _.union($scope.subtipos, el.ImovelSubtipo);
                    };
                });
            });
        };



    }]);
});

